// Imports
import { gsap } from "gsap";

class Popup {
    constructor() {
        this.banner = document.querySelector('.popup');
        this.closeButton = this.banner?.querySelector('.popup-close');
        this.storageKey = 'popupClosed';
        this.init();
    }

    init() {
        if (!this.banner) return;

        if (sessionStorage.getItem(this.storageKey) === 'true') {
            this.banner.remove();
        } else {
            this.showBanner();
        }
    }

    showBanner() {
        gsap.fromTo(this.banner,
            {
                y: '100%',
            },
            {
                y: 0,
                duration: 0.5,
                delay: 1,
                ease: 'power3.out'
            }
        );
        this.addCloseEvent();
    }

    addCloseEvent() {
        if (!this.closeButton) return;
        this.closeButton.addEventListener('click', () => this.closeBanner());
    }

    closeBanner() {
        gsap.to(this.banner, {
            y: '100%',
            duration: 0.5,
            ease: 'power3.in',
            onComplete: () => {
                this.banner.remove();
                sessionStorage.setItem(this.storageKey, 'true');
            }
        });
    }
}

export default new Popup();
